import axios from 'axios'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY

const USER_LOG_URL = `${API_URL}/v1/user-log`

const STEP_VI_NAMES: Record<number, string> = {
  0: 'PERSONAL_DATA_PROCESSING_CONSENT',
  1: 'REGISTER_INFORMATION',
  2: 'VERIFY_OTP',
  3: 'GO_TO_ID_CARD_GUIDE',
  4: 'PREPARE_ID_CARD_SCAN',
  5: 'FACE_SCAN_GUIDE',
  6: 'EKYC_FACE_SCAN',
  7: 'PERSONAL_INFORMATION',
  8: 'ACCOUNT_INFORMATION',
  9: 'BANK_INFORMATION',
  10: 'INVESTMENT_INFORMATION',
  11: 'ACCOUNT_OPENING_COMPLETED',
  12: 'TERMS_AND_CONDITIONS_CONFIRMATION',
}

export const sendStepLog = async (
  sessionID: string | null,
  stepIndex: number,
  data: Record<string, any> = {},
  extraMeta?: {mobile?: string; email?: string; idno?: string}
): Promise<void> => {
  try {
    // Skip if no meaningful data
    if (Object.keys(data).length === 0) return

    const payload = [
      {
        meta_data: {
          timestamp: Date.now().toString(),
          type: 'OPENACCOUNT',
          req_id: `${sessionID ?? 'anonymous'}-${crypto.randomUUID()}`,
          session_id: sessionID,
          step: STEP_VI_NAMES[stepIndex] ?? `Bước ${stepIndex}`,
          ...(extraMeta?.mobile ? {mobile: extraMeta.mobile} : {}),
          ...(extraMeta?.email ? {email: extraMeta.email} : {}),
          ...(extraMeta?.idno ? {idno: extraMeta.idno} : {}),
        },
        data,
      },
    ]
    await axios.post(USER_LOG_URL, payload, {
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    })
  } catch {
    // log failure must not affect main flow
  }
}
